import React from 'react';
import { motion } from 'framer-motion';
export function WelcomeSection() {
  return <section className="relative py-24 bg-earth-900 overflow-hidden" data-id="element-132">
      <div className="absolute inset-0 bg-grain opacity-15 pointer-events-none mix-blend-overlay" data-id="element-133"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-134">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-135">
          <h2 className="font-serif text-4xl md:text-5xl text-gold-400 mb-6" data-id="element-136">
            Welcome - This Is Where Your Next Adventure Begins
          </h2>
          <div className="h-1 w-24 bg-gold-400/30 mx-auto rounded-full" data-id="element-137"></div>
        </motion.div>

        <div className="grid md:grid-cols-1 gap-12 text-center" data-id="element-138">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-139">
            <h3 className="text-2xl font-serif text-cream-100 mb-6 italic" data-id="element-140">
              "My coaching is built on a simple belief: when you reconnect with
              nature and ground yourself, you rediscover the clarity, courage,
              and curiosity you need to move forward."
            </h3>

            <p className="text-lg text-cream-50/80 leading-relaxed max-w-2xl mx-auto" data-id="element-141">
              Life can feel heavy when you're unsure which path to take. In a
              world that constantly pulls you in every direction, it's easy to
              lose touch with who you truly are. I guide individuals who feel
              stuck or at a crossroads. Together, we slow down, breathe, and
              from that space, you learn to trust your choices again.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}